import { validate } from 'parameter-validator';

import { useMutation } from '../../index';
import permissions from '../../Apollo/permissions';
import useTrackWithUser from '../../hooks/useTrackWithUser';

import {
  buildVariables as buildConsentCategoryVariables,
  updateConsentCategoryMutation,
} from './update-consent-category-mutation-builder';

export default function useUpdateConsentCategory(options = {}) {
  const [trackWithUser] = useTrackWithUser('edits_category');
  const [executeMutation, response] = useMutation(updateConsentCategoryMutation, {
    successMsg: 'Consent Category updated.',
    context: { permission: permissions.updateConsentCategory },
    ...options,
  });

  const updateConsentCategory = args => {
    const { consentCategoryId } = validate(args, ['consentCategoryId']);
    const { code, name } = args;
    const variables = buildVariables({ consentCategoryId, name, code });
    return executeMutation(variables).then(response => {
      if (!response.errors) {
        trackWithUser({ consentCategoryId, name, code });
      }
    });
  };

  return [updateConsentCategory, response];
}
function buildVariables({ consentCategoryId, name, code }) {
  return {
    variables: {
      ...buildConsentCategoryVariables({ consentCategoryId, name, code }),
    },
  };
}
